import { EuiFieldNumber, EuiFormRow } from "@elastic/eui";
import React from "react";

function MeetingMaximumUsersField({
  value,
  setSize,
}: {
  value: number;
  setSize: React.Dispatch<React.SetStateAction<number>>;
}) {
  return (
    <EuiFormRow label="Nombre de participants prévisionnel (indicatif)">
      <EuiFieldNumber
        min={1}
        max={50}
        placeholder="Nombre de participants"
        value={value}
        onChange={(e) => {
          if (!e.target.value.length || parseInt(e.target.value) === 0)
            setSize(1);
          else if (parseInt(e.target.value) > 50) setSize(50);
          else setSize(parseInt(e.target.value));
        }}
      />
    </EuiFormRow>
  );
}

export default MeetingMaximumUsersField;
